/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Incendie
 * 1 = Explosion
 * 2 = Accident
 * 3 = Pollution
 * 4 = Vols
 * 5 = Conflit
 * 6 = Agression
 */
export enum RapportIncidentTypeIncident {
  Incendie = 0,
  Explosion = 1,
  Accident = 2,
  Pollution = 3,
  Vols = 4,
  Conflit = 5,
  Agression = 6
}
